var React = require('react');

function Movie (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.8,9.7c0.4-0.2,0.6-0.4,0.8-0.5c1.3-1,2.7-2,4-3c0.2-0.1,0.5-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.3,0.7c0,3.5,0,7.1,0,10.6\n\tc0,0.7-0.4,0.9-1,0.4c-1.4-1-2.8-2-4.2-3c-0.2-0.1-0.4-0.2-0.7-0.4c0,0.3-0.1,0.4-0.1,0.6c0,0.7,0,1.4,0,2c0,0.7-0.4,1-1.1,1\n\tc-4.4,0-8.8,0-13.2,0c-0.7,0-1.1-0.5-1.1-1.3c0-2.5,0-5.1,0-7.6c0-0.6,0-1.2,0-1.9c0-0.7,0.3-1.1,1.1-1.2c0.2,0,0.5,0,0.7,0\n\tC7.1,6,11,6,15,6c0.3,0,0.5,0,0.8,0c0.6,0.1,0.9,0.4,1,1c0,0.6,0,1.2,0,1.8C16.8,9.1,16.8,9.3,16.8,9.7z"}));
}

Movie.defaultProps = {"version":"1.1","id":"paste","x":"0px","y":"0px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = Movie;

Movie.default = Movie;
